<div class="table-layout">
  <ion-grid class="p-0 h-100">
    <ion-row class="p-0 mb-20">
      <ion-col size="10" size-md="11">
        <div>
          <ion-label class="font_bold black_color" *ngIf="buttonName != 'Repository'">{{buttonName}}
            ({{gridData.totalCount}})</ion-label>
          <ion-label class="font_bold black_color" *ngIf="buttonName == 'Repository'">{{buttonName}} :
            ({{loggedInCompanyIndustryName}})</ion-label>
        </div>
      </ion-col>

      <ion-col size class="ion-text-end">
        <img [mat-dialog-close] src="././assets/icon/close_icon.png" class="cp">
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="7" size-md="5" size-lg="4">
        <mat-form-field class="w-100 mat-height40 mat-input-style searchFilter">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchText" (input)="onSearch(searchText)">
        </mat-form-field>
      </ion-col>
      <ion-col size="5" size-md="7" size-lg="8">
        <div class="display-end p-0">
          <!-- <button *ngIf="buttonName == 'Previous Months KPI' && goalSettingAtAllLevels" (click)="useKpiForThisMonth()" type="button"
            class="add_btn fs-14 fs_12ForMobile mr-10" [ngClass]="{'disableBtn' : selectedKPIList.length == 0}"
            [disabled]="selectedKPIList.length == 0" [style.background-color]="buttonColorName">Use KPI for this Month
          </button> -->
          <button [ngClass]="{'disableBtn' : renderData.length == 0}" [disabled]="renderData.length == 0" type="button"
            class="back_btn d-flex" (click)="downloadKpis()">
            <span class="material-icons mr-5">download</span><span *ngIf="!mobileResponsiveService.hideForMobile">Download</span></button>
        
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="buttonName == 'Previous Months KPI' && goalSettingAtAllLevels" class="mt-10 mb-10">
      <ion-col size="12" size-md="3">
        <ng-multiselect-dropdown class="d-flex w-100" [placeholder]="'Select Months'" [settings]="dropdownSettings"
          [data]="notApprovedMonths" [(ngModel)]="selectedMonthsForKpiAdd" (onSelectAll)="selectAllMonths($event)"
          (onDeSelectAll)="onDeSelectAllMonths()"></ng-multiselect-dropdown>
      </ion-col>
      <ion-col size="4" size-md="8">
        <div class="center-content">
          <button (click)="copyPreviousKPI()"
          type="button" class="add_btn fs-14 fs_12ForMobile mr-10" [ngClass]="{'disableBtn' : selectedKPIList.length == 0 || selectedMonthsForKpiAdd.length == 0}"
          [disabled]="selectedKPIList.length == 0 && selectedMonthsForKpiAdd.length == 0" [style.background-color]="buttonColorName">Paste
        </button>
        <label *ngIf="selectedKPIList.length != 0" class="formLabelSemiBoldfs14 mb-5">Total Selected KPIs Weightage:&nbsp;{{totalSelectedWtCount}}</label>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="buttonName == 'Repository'" class="mb-10">
      <ion-col size="12" size-md="4">
        <div class="formLabelSemiBoldfs14  mb-5">Sub Industries<span class="red-cl">&nbsp;*</span></div>
        <ng-multiselect-dropdown class="d-flex w-100" [placeholder]="'Select Sub Industries'" [settings]="dropdownSettings"
          [data]="subIndustriesList" [(ngModel)]="selectedSubIndustries" (onSelect)="getRepositoryKPIs()"
          (onDeSelect)="getRepositoryKPIs()" (onSelectAll)="selectAllSubIndusries($event)"
          (onDeSelectAll)="onDeSelectAllSubIndusries()"></ng-multiselect-dropdown>

        <!-- <ng-select [closeOnSelect]="false" placeholder="Select Sub Industries" [multiple]="true" class="w-100"
          [(ngModel)]="selectedSubIndustries" (change)="getRepositoryKPIs()">
          <ng-option [value]="item.id" *ngFor="let item of subIndustriesList">{{item.name}}</ng-option>
        </ng-select> -->
      </ion-col>
      <ion-col size="12" size-md="4">
        <div class="formLabelSemiBoldfs14 mb-5">Dept/Function<span class="red-cl">&nbsp;*</span></div>
        <ng-multiselect-dropdown class="d-flex  w-100" [placeholder]="'Select Dept/Function'" [settings]="dropdownSettings"
          [data]="functionList" [(ngModel)]="selectedFunction" (onSelect)="getRepositoryKPIs()"
          (onDeSelect)="getRepositoryKPIs()" (onSelectAll)="selectAllFunctions($event)"
          (onDeSelectAll)="onDeSelectAllFunctions()"></ng-multiselect-dropdown>

        <!-- <ng-select [closeOnSelect]="false" placeholder="Select Function" [multiple]="true" class="w-100"
          [(ngModel)]="selectedFunction" (change)="getRepositoryKPIs()">
          <ng-option [value]="item" *ngFor="let item of functionList">{{item}}</ng-option>
        </ng-select> -->
      </ion-col>
      <ion-col size="12" size-md="4">
        <div class="formLabelSemiBoldfs14 mb-5">Designation<span class="red-cl">&nbsp;*</span></div>
        <ng-multiselect-dropdown class="d-flex w-100" [placeholder]="'Select Designation'" [settings]="dropdownSettings"
          [data]="designationList" [(ngModel)]="selectedDesignation" (onSelect)="getRepositoryKPIs()"
          (onDeSelect)="getRepositoryKPIs()" (onSelectAll)="selectAllDesignation($event)"
          (onDeSelectAll)="onDeSelectAllDesignation()"></ng-multiselect-dropdown>
        <!-- <ng-select [closeOnSelect]="false" placeholder="Select Designation" [multiple]="true" class="w-100"
          [(ngModel)]="selectedDesignation" (change)="getRepositoryKPIs()">
          <ng-option [value]="item" *ngFor="let item of designationList">{{item}}</ng-option>
        </ng-select> -->
      </ion-col>
    </ion-row>
    <ion-row class="p-0 mb-10">
      <ion-col class="p-0">
        <div class="table-container">
          <table class="hover">
            <thead>
              <tr>
                <th class="width1 mat-checkbox-style"
                  *ngIf="buttonName == 'Previous Months KPI' && goalSettingAtAllLevels">
                  <mat-checkbox [(ngModel)]="selectAllCheckbox" [checked]="selectAllCheckbox==true" value=true
                    (change)="selectALLRecords($event)"></mat-checkbox>
                </th>
                <th [ngClass]="{'p-5' : buttonName != 'Previous Months KPI' || !goalSettingAtAllLevels}"
                  class="fs-16 fs_14ForMobile font_regular cl-black" *ngFor="let item of gridData.columnInfo">
                  <label class="verticle-center icon-style">{{item.label}}
                    <!-- <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="onSortAssending(item)">arrow_drop_up</i>
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                        (click)="onSortDesending(item)">arrow_drop_down</i>
                    </div> -->
                  </label>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white" *ngIf="renderData.length !== 0">
              <tr *ngFor="let item of renderData;let i=index">
                <td class="width1 mat-checkbox-style"
                  *ngIf="buttonName == 'Previous Months KPI' && goalSettingAtAllLevels">
                  <mat-checkbox [(ngModel)]="item.checkboxCheck" [checked]="item.checkboxCheck" value=true
                    (change)="selectSingleRecord($event,item,i)"></mat-checkbox>
                </td>
                <ng-container *ngFor="let innerItem of item">
                  <td [ngClass]="{'p-5' : buttonName != 'Previous Months KPI' || !goalSettingAtAllLevels}"
                    *ngIf="innerItem.key !== 'id'" class="fs-16 fs_14ForMobile font_regular">{{innerItem.value}}</td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
      <ion-col size="12" class="p-0" *ngIf="renderData.length === 0">
        <div class="bg-white text-center font_medium">No Data Available</div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="renderData.length != 0">
      <ion-col size="12" size-md="8" class="center-content">
        <ion-label *ngIf="buttonName != 'Previous Months KPI'" class="fs-14 fs_12ForMobile font_bold black_color fs-12ForMobile">Showing {{showingCount}} to {{showingOfCount}} of
          {{gridData.totalCount}} entries</ion-label>
          <ion-label *ngIf="buttonName == 'Previous Months KPI'" class="fs-14 fs_12ForMobile font_bold black_color">
            {{gridData.totalCount}} entries</ion-label>
      </ion-col>
      <ion-col size="12" size-md="4" class="text-right display-end">
        <ul class="dt_pagination" *ngIf="buttonName != 'Previous Months KPI'">
          <ion-row class="float-right pgintn">
            <li class="active fs-16 fs_14ForMobile font_regular">{{currentPageNumberOfKpis}}</li>
            <span class="fs-14 fs_12ForMobile font_regular p-10 p-5ForMobile">of {{gridData.totalNoOfPages}}</span>
            <li class="fs-24 fs_18ForMobile cp" (click)="previousPageKpi()" [ngClass]="{'disableBtn': currentPageNumberOfKpis==1}">&lt;
            </li>
            <li class="fs-24 fs_18ForMobile cp" (click)="nextPageKpi()"
              [ngClass]="{'disableBtn': currentPageNumberOfKpis >= gridData.totalNoOfPages}">&gt;</li>
          </ion-row>
        </ul>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
